import { Loader } from '@payright/web-components';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../reducers';
import {
  FormHouseholdExpenses,
  FormHouseholdExpensesFormData,
} from './components/forms/FormHouseholdExpenses';
import { submitHouseholdExpenses } from '../../reducers/customer-slice';
import { AppThunkDispatch } from '../../util/store';
import { AlertSliceError } from '../../components/alert-slice-error';
import { useAppStepNavigation } from '../../util/hooks/useAppStepNavigation';

export const HouseholdExpensesContent = () => {
  const { goToStep } = useAppStepNavigation();
  const dispatch = useDispatch<AppThunkDispatch>();
  const { loading: checkoutLoading, checkout } = useSelector((state: RootState) => state.checkout);
  const {
    loading: customerLoading,
    householdDetails,
    hasErrors,
    errorMessage,
  } = useSelector((state: RootState) => state.customer);

  const { plan } = useSelector((state: RootState) => state.plan);

  const assessmentTier = plan?.assessmentTier;
  const showLivingExpenses = assessmentTier === '2' || assessmentTier === '3';
  const showFinancialExpenses = assessmentTier === '3';

  const customerError = {
    hasErrors,
    errorMessage,
    errorTitle: 'There was an error with your submission',
  };

  const checkoutId = checkout?.id ?? '';
  const redirectUrl = checkout?.attributes?.redirectUrl ?? '';

  const handleSubmit = async (formData: FormHouseholdExpensesFormData) => {
    const householdDetails = {
      dependants: formData.householdDetails.dependants,
      relationshipStatus: formData.householdDetails.relationshipStatus,
      incomePercentage:
        formData.householdDetails.relationshipStatus === 'Single'
          ? 100
          : Number(formData.householdDetails.incomePercentage ?? 0),
    };

    dispatch(
      submitHouseholdExpenses(checkoutId, checkout!.customerId!, {
        householdDetails,
        ...(showLivingExpenses
          ? {
              expenseDetails: {
                ...(showFinancialExpenses
                  ? {
                      financialExpensesAmount: Number(
                        formData.expenseDetails.financialExpensesAmount ?? 0
                      ),
                      financialExpensesFrequency:
                        formData.expenseDetails.financialExpensesFrequency,
                    }
                  : {}),
                livingExpensesAmount: Number(formData.expenseDetails.livingExpensesAmount ?? 0),
                livingExpensesFrequency: formData.expenseDetails.livingExpensesFrequency,
                loanCount: Number(formData.expenseDetails.loanCount),
              },
            }
          : {}),
      })
    ).then((nextStep) => {
      goToStep(nextStep);
    });
  };

  if (checkoutLoading || (customerLoading && !householdDetails.relationshipStatus)) {
    return <Loader text="" />;
  }

  return (
    <FormHouseholdExpenses
      dependants={householdDetails.dependants}
      relationshipStatus={householdDetails.relationshipStatus}
      incomePercentage={householdDetails.incomePercentage}
      loading={customerLoading}
      alert={<AlertSliceError slice={customerError} />}
      onSubmit={handleSubmit}
      showLivingExpenses={showLivingExpenses}
      showFinancialExpenses={showFinancialExpenses}
    />
  );
};
